import { getProperty } from 'customer-data-objects/model/ImmutableModel';
import { OrderedMap } from 'immutable';
import memoize from 'transmute/memoize';
import { CUSTOM_CELL_COMPONENTS, CUSTOM_COLUMN_COMPONENTS, getColumnLabel } from './table';
import { CUSTOM_COLUMN_WIDTHS, COLUMN_TO_CRM_SEARCH_PROPERTY, MINIMUM_COLUMN_WIDTH, DEFAULT_COLUMN_WIDTH } from '../constants/table';
import get from 'transmute/get';
import { PropertyCell } from 'framework-data-table';
import { getId } from 'customer-data-objects/record/ObjectRecordAccessors';
import { reportNewTasksWarning } from '../tracking/errors';
import { associationColumnNameToAssociationSpec, isCustomObjectAssociationColumnName } from './associationColumnNames';
import makeCellForAssociationType from '../components/table/associations/makeCellForAssociationType';
import { TASK_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const getMemoizedColumnsV2 = memoize(({
  columnNames,
  customAssociationColumnNamesToDefinitions = OrderedMap(),
  properties = OrderedMap(),
  staticColumns = [],
  columnWidths = {}
}) => {
  return columnNames.map(column => {
    return {
      columnName: column,
      CellComponent: ({
        row,
        requiredCellProps
      }) => {
        const CustomCellComponent = CUSTOM_CELL_COMPONENTS[column];
        if (CustomCellComponent) {
          return /*#__PURE__*/_jsx(CustomCellComponent, {
            original: row,
            value: getProperty(row, column),
            requiredCellProps: requiredCellProps
          });
        }
        const CellComponent = CUSTOM_COLUMN_COMPONENTS[column];
        if (CellComponent) {
          return /*#__PURE__*/_jsx("td", Object.assign({}, requiredCellProps, {
            children: /*#__PURE__*/_jsx(CellComponent, {
              original: row,
              value: getProperty(row, column)
            })
          }));
        }
        if (isCustomObjectAssociationColumnName(column)) {
          const {
            associationCategoryId,
            associationTypeId
          } = associationColumnNameToAssociationSpec(column);
          const ColumnComponent = makeCellForAssociationType(associationCategoryId, associationTypeId);
          return /*#__PURE__*/_jsx("td", Object.assign({}, requiredCellProps, {
            children: /*#__PURE__*/_jsx(ColumnComponent, {
              original: row
            })
          }));
        }
        return /*#__PURE__*/_jsx(PropertyCell
        // TODO This prop is used to assign owners to unassigned objects
        // Can follow-up to investigate adding this functionality into tasks
        , {
          canEditObject: false
          // We shouldn't have any property cells that render based on a second property value,
          // so leaving this unimplemented for now and just logging a warning
          ,
          getSecondaryPropertyValue: name => {
            reportNewTasksWarning('getSecondaryPropertyValue called', {
              tags: {
                propertyName: name
              }
            });
            return undefined;
          },
          objectId: getId(row),
          objectTypeId: TASK_TYPE_ID
          // TODO clean up unknown type
          ,
          propertyDefinition: get(column, properties),
          requiredCellProps: requiredCellProps,
          value: getProperty(row, column)
        });
      },
      HeaderContentComponent: ({
        columnName
      }) => /*#__PURE__*/_jsx(_Fragment, {
        children: getColumnLabel({
          columnName,
          customAssociationColumnNamesToDefinitions,
          properties
        })
      }),
      reorderable: !staticColumns.includes(column),
      sortable: Boolean(COLUMN_TO_CRM_SEARCH_PROPERTY[column]),
      width: Math.max(columnWidths[column] || CUSTOM_COLUMN_WIDTHS[column] || DEFAULT_COLUMN_WIDTH, MINIMUM_COLUMN_WIDTH)
    };
  });
});